/**
 * Created by torugo on 28/04/2017.
 */
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  }            from "@angular/core";
import { CommonModule }        from "@angular/common";
import { ReactiveFormsModule,FormsModule } from "@angular/forms";
import { TextMaskModule } from 'angular2-text-mask';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import {TranslateModule} from '../../../translate-module';
import {OpenLinkActionComponent} from './openLinkAction'
import { TalkActionComponent } from "./talkAction";
import { VideoShowActionComponent } from "./videoShow";
import { AvatarChangeActionComponent } from "./avatarChangeAction";
import { AudioShowActionComponent } from "./audioShow";
import { ImageShowActionComponent } from "./imageShow";
import { VideoShowActionSecondComponent } from "./videoShowActionSecond";
import { AudioShowActionSecondComponent } from "./audioShowActionSecond";
import { ImageShowActionSecondComponent } from "./imageShowActionSecond";
import { EmbedActionComponent } from "./embedAction";
import { NpcActionComponent } from "./npcAction";
import { ContainerActionComponent } from "./containerAction";
import { addItensActionComponent } from "./addItens";
import { removeItensActionComponent } from "./removeItens";
import { ActionTriggerComponent } from "../triggers/actionTriggers";
import { DoorActionComponent } from "./doorAction";
import { DoorActionSecondComponent } from "./doorActionSecond";
import { unequipActionComponent } from "./unequipAction";
import { EquipActionComponent } from "./equipAction";
import { WritActionComponent } from "./WritAction";
import { WritActionSecondComponent } from "./WritActionSecond";
import { removeItensActionSecondComponent } from "./removeItensActionSecond";
import { addItensActionSecondComponent } from "./addItensActionSecond";
import { ParticlesActionComponent } from "./particles";
import { ParticleCurveComponent } from "./particleCurve";
import { moveBackActionComponent } from "./moveBackAction";
import { MovableActionComponent } from "./movableAction";
import { ClothActionComponent } from "./clothAction";
import { WalkAnimationActionComponent } from "./walkAnimation";
import { LightActionComponent } from "./lightAction";
import { WaterActionComponent } from "./waterAction";
import { SittableActionComponent } from "./sittableAction";
import { TextActionComponent } from "./textAction";

import { BaseActionComponent } from "./baseAction";
import { PanoramaShowActionComponent } from "./panoramaShow";
import { WalkActionComponent } from "./walkableAction";

@NgModule({
    imports : [
      CommonModule,
      ReactiveFormsModule,
      FormsModule,
      TextMaskModule,
      NguiAutoCompleteModule,
      TranslateModule,
    ],
    declarations : [
      OpenLinkActionComponent,
      TalkActionComponent,
      VideoShowActionComponent,
      AvatarChangeActionComponent,
      AudioShowActionComponent,
      ImageShowActionComponent,
      EmbedActionComponent,
      VideoShowActionSecondComponent,
      AudioShowActionSecondComponent,
      ImageShowActionSecondComponent,
      NpcActionComponent,
      ContainerActionComponent,
      addItensActionComponent,
      addItensActionSecondComponent,
      removeItensActionComponent,
      removeItensActionSecondComponent,
      ActionTriggerComponent,
      DoorActionComponent,
      DoorActionSecondComponent,
      unequipActionComponent,
      EquipActionComponent,
      WritActionComponent,
      WritActionSecondComponent,
      ParticlesActionComponent,
      ParticleCurveComponent,
      moveBackActionComponent,
      WalkAnimationActionComponent,
      MovableActionComponent,
      ClothActionComponent,
      LightActionComponent,
      WaterActionComponent,
      SittableActionComponent,
      TextActionComponent,
      PanoramaShowActionComponent,
      WalkActionComponent,
      BaseActionComponent

    ],
    providers : [
    ],
    exports:[
      OpenLinkActionComponent,
      TalkActionComponent,
      VideoShowActionComponent,
      AvatarChangeActionComponent,
      AudioShowActionComponent,
      ImageShowActionComponent,
      VideoShowActionSecondComponent,
      AudioShowActionSecondComponent,
      ImageShowActionSecondComponent,
      EmbedActionComponent,
      NpcActionComponent,
      ContainerActionComponent,
      addItensActionComponent,
      addItensActionSecondComponent,
      removeItensActionComponent,
      removeItensActionSecondComponent,
      DoorActionComponent,
      DoorActionSecondComponent,
      ActionTriggerComponent,
      unequipActionComponent,
      EquipActionComponent,
      WritActionComponent,
      WritActionSecondComponent,
      ParticlesActionComponent,
      ParticleCurveComponent,
      WalkAnimationActionComponent,
      moveBackActionComponent,
      MovableActionComponent,
      ClothActionComponent,
      LightActionComponent,
      WaterActionComponent,
      SittableActionComponent,
      TextActionComponent,
      PanoramaShowActionComponent,
      WalkActionComponent,
      BaseActionComponent

    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ActionModule {}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/action.module.ts